export default class Address {

    constructor() {
        this.name = "";
        this.master_brewer="";
        this.street1 = "";
        this.street2 = "";
        this.zip = "";
        this.city = "";
        this.country = "";
        this.vatid = "";
        this.future_award = null;
    }
}